.mainContentSection {
  background-color: white;
}

.alternativeSection {
  background-color: #f9f9f9;
  padding: 140px 0;
  width: 100%;
}

.alternativeContainer {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 20px;
}

.contentSection {
  width: 100%;
  max-width: 1100px;
}

.heading {
  font-size: 32px;
  color: #3caeb0;
  font-weight: bold;
  line-height: 1.1em;
}

.subsectionHeading {
  color: #3caeb0;
  font-size: 24px;
  line-height: 1.1em;
  font-weight: 700;
}

.subheading {
  color: #3caeb0;
  font-size: 20px;
  line-height: 1.1em;
  font-weight: 600;
}

.content {
  line-height: 1.55em;
  letter-spacing: normal;
  text-wrap: pretty;
}

.form {
  padding: 48px 0;
}

.faqSection {
  background-color: #e7f4f5;
  padding: 60px 0;
  width: 100%;
}

.faqContainer {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 20px;
}

.faqTitle {
  font-size: 48px;
  color: #3caeb0;
  font-weight: bold;
  line-height: 1.1em;
  margin-bottom: 40px;
  text-align: center;
}

.faqItem {
  background-color: white;
  border-radius: 8px;
  margin-bottom: 20px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.faqQuestion {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  padding: 24px;
  color: #3caeb0;
  font-weight: 600;
  font-size: 22px;
}

.faqAnswer {
  height: 0;
  overflow: hidden;
  transition: height 0.3s ease;
  padding: 0 24px;
}

.faqAnswerOpen {
  height: auto;
  padding: 0 24px 24px 24px;
}

.faqPlusIcon {
  font-size: 28px;
  transition: transform 0.3s ease;
  display: inline-block;
  width: 28px;
  height: 28px;
  text-align: center;
  line-height: 24px;
}

.faqPlusIconOpen {
  transform: rotate(45deg);
}

@media (min-width: 768px) {
  .heading {
    font-size: 50px;
  }

  .subsectionHeading {
    font-size: 35px;
  }

  .subheading {
    font-size: 24px;
  }

  .form {
    padding: 96px 20px;
  }
}
